import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "group" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ active: $setup.value === 0 }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.value = 0))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("position.left")), 1),
      ($props.position === '0')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("position.my")), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({ active: $setup.value === 1 }),
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.value = 1)),
      style: {"margin-left":"15px"}
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("position.right")), 1),
      ($props.position === '1')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("position.my")), 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}